import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import { NavLink, useNavigate } from "react-router-dom";
//Icon Imports
import IconButton from "@mui/material/IconButton";
import Zoom from "@mui/material/Zoom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useMediaQuery } from "@mui/material";
import SiteLogo from "../Assets/images/siteLogoWhite.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  closeExpand,
  openExpand,
  trigger,
} from "../../redux/reducers/SideExpand";
import { motion, AnimatePresence } from "framer-motion";
import { Tooltip } from "@mui/material";
import configServ from "../../services/config";

// icon
import InventoryIcon from "@mui/icons-material/Inventory";
import CategoryIcon from "@mui/icons-material/Category";
import AndroidIcon from "@mui/icons-material/Android";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import GroupsIcon from "@mui/icons-material/Groups";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import ExtensionIcon from "@mui/icons-material/Extension";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PhonelinkSetupIcon from "@mui/icons-material/PhonelinkSetup";
import ApartmentIcon from "@mui/icons-material/Apartment";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import BadgeIcon from "@mui/icons-material/Badge";
import AppsOutageIcon from "@mui/icons-material/AppsOutage";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import CommentIcon from "@mui/icons-material/Comment";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import ReportIcon from "@mui/icons-material/Report";
import ContactlessIcon from "@mui/icons-material/Contactless";
// import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import BrowserUpdatedIcon from "@mui/icons-material/BrowserUpdated";
import PaidIcon from "@mui/icons-material/Paid";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import { useState } from "react";
import LoaderNew from "../Loader/LoaderNew";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import PortableWifiOffIcon from '@mui/icons-material/PortableWifiOff';
import DevicesFoldIcon from '@mui/icons-material/DevicesFold';
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const NavToolTip = ({ text, children }) => {
  return (
    <Tooltip
      TransitionComponent={Zoom}
      leaveDelay={200}
      title={text}
      placement="right"
      arrow
      sx={{ fontSize: "16px" }}
    >
      {children}
    </Tooltip>
  );
};

export default function Sidebar() {
  //#region code
  const dispatch = useDispatch();
  const open = useSelector((state) => state.sideExpand.open);
  const isMobile = useMediaQuery("(max-width:600px)");

  const { is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables
  );

  const { company_type } = useSelector((state) => state.admin);

  const [isMenuExpanded, setIsMenuExpanded] = React.useState(false);
  const [selectedMenu, setSelectedMenu] = React.useState(0);

  React.useEffect(() => {
    if (isMobile) {
      dispatch(closeExpand());
    } else {
      dispatch(openExpand());
    }
  }, [isMobile]);

  const handleDrawerOpen = () => {
    dispatch(trigger());
  };

  const handleDrawerClose = () => {
    // setOpen(false);
    dispatch(trigger());
  };

  const handleExpand = (number) => {
    setSelectedMenu(number);
    setIsMenuExpanded(!isMenuExpanded);
  };

  const navigate = useNavigate();
  const [expandedMenu, setExpandedMenu] = React.useState(null); // Track expanded menu
  const [menus, setMenus] = React.useState([]);

  const handleMenuClick = (menu) => {
    if (menu.submenus.length === 0) {
      navigate(menu.routes); // Navigate directly
    } else {
      setExpandedMenu(expandedMenu === menu.id ? null : menu.id); // Toggle submenu
    }
  };

  const handleSubmenuClick = (route) => {
    navigate(route);
  };

  const [loading, setLoading] = useState(false);

  const fetchMenuList = async () => {
    setLoading(true);
    try {
      const res = await configServ.getActiveMenusWithSubmenus();
      if (res.status === 200 && Array.isArray(res.data)) {
        setMenus(res.data || []);
      } else {
        setMenus([]);
        // toast.error("Failed to fetch menu list.");
      }
    } catch (e) {
      // toast.error("An error occurred!");
      console.log(e);
      setMenus([]);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchMenuList();
  }, []);

  // Icon mapping object
  const iconMapping = {
    dashboard: <DashboardIcon />,
    inventory: <InventoryIcon />,
    brand: <AndroidIcon />,
    category: <CategoryIcon />,
    invoice: <ReceiptIcon />,
    subscriptions: <SubscriptionsIcon />,
    sales: <AddShoppingCartIcon />,
    group: <GroupsIcon />,
    unit: <AcUnitIcon />,
    item: <ExtensionIcon />,
    hsn: <AutoAwesomeMotionIcon />,
    super: <SupervisedUserCircleIcon />,
    location: <AddLocationAltIcon />,
    catalog: <CastForEducationIcon />,
    customers: <Diversity1Icon />,
    lead: <LeaderboardIcon />,
    account: <Diversity3Icon />,
    master: <FamilyRestroomIcon />,
    supplier: <PrecisionManufacturingIcon />,

    transaction: <ContactlessIcon />,
    cashvoucher: <ReceiptIcon />,
    journal: <ReceiptLongIcon />,
    gst: <AccountBalanceWalletIcon />,
    stockupdate: <BrowserUpdatedIcon />,
    puchaseorder: <ShoppingBasketIcon />,
    purchasebill: <PaidIcon />,
    dispatch: <LocalCarWashIcon />,
    reports: <ReportIcon />,
    outstanding: <AppsOutageIcon />,
    gstreport: <CommentIcon />,
    salesreport: <ForwardToInboxIcon />,
    salessummary: <AssessmentIcon />,
    salessummary2: <AttachEmailIcon />,
    trial: <AssuredWorkloadIcon />,
    ledger: <BadgeIcon />,
    loghistory: <EditLocationAltIcon />,
    companyregister: <ApartmentIcon />,
    configuration: <PhonelinkSetupIcon />,
    profile: <AccountBoxIcon />,
    unregister: <MarkUnreadChatAltIcon />,
    accessmaster: <VpnKeyIcon />,
    menupermission: <GppMaybeIcon />,
    salescancel: <PortableWifiOffIcon/>,
    invoicecancel: <DevicesFoldIcon/>
  };
  const getIcon = (iconName) => {
    return iconMapping[iconName.toLowerCase()] || null; // Return null if icon doesn't exist
  };

  // permission
  // Function to filter menus based on permissions
  const filterMenus = (menus) => {
    if (is_admin || is_super) return menus; // Show all menus if is_admin or is_super is true

    return menus
      .map((menu) => {
        // Check menu permission
        const hasMenuPermission = permissions.includes(menu.permission);

        // Filter submenus based on their permissions
        const filteredSubmenus = menu.submenus.filter((submenu) =>
          submenu.permission ? permissions.includes(submenu.permission) : false
        );

        // Include menu if it has permission or has filtered submenus
        if (hasMenuPermission || filteredSubmenus.length > 0) {
          return { ...menu, submenus: filteredSubmenus };
        }
        return null;
      })
      .filter((menu) => menu !== null); // Remove menus that don't have permission and no valid submenus
  };

  // Get filtered menus
  const filteredMenus = filterMenus(menus);
  //#endregion

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        open={open}
        PaperProps={{
          sx: {
            backgroundColor: "#333",
          },
        }}
      >
        <DrawerHeader
          sx={{
            display: 'flex',
            alignItems: 'center', // Vertically centers content
            justifyContent: 'space-between',
            padding: '0 8px',
            minHeight: '48px', // Adjust as needed for compactness
          }}
        >
          {open && (
            <img
              src={SiteLogo}
              alt="logo"
              width="150"
              height="90" // Explicit height to prevent extra space
              style={{
                display: 'block', // Prevents inline images from adding extra space
                margin: 0,
                padding: 0,
              }}
            />
          )}
          <IconButton onClick={handleDrawerClose}>
            {open ? (
              <ArrowBackIosNewIcon sx={{ color: 'white' }} />
            ) : (
              <ArrowForwardIosIcon sx={{ color: 'white' }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoaderNew /> {/* Replace with your loader icon/component */}
          </div>
        ) : (
          <>
            {" "}
            {/* Iterate Menus */}
            {filteredMenus.map((menu) => (
              <div key={menu.id}>
                {/* Main Menu */}
                <div
                  onClick={() => handleMenuClick(menu)}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    color: "white",
                    display: "flex",
                    justifyContent: open ? "space-between" : "center",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px", // Add spacing between icon and name
                    }}
                  >
                    <NavToolTip text={menu.name}>
                      {getIcon(menu.icon)}
                    </NavToolTip>{" "}
                    {open && menu.name}
                  </span>
                  {menu.submenus.length > 0 &&
                    (expandedMenu === menu.id ? (
                      <ArrowDropUpIcon />
                    ) : (
                      <ArrowDropDownIcon />
                    ))}
                </div>

                {/* Submenus */}
                <AnimatePresence>
                  {expandedMenu === menu.id && menu.submenus.length > 0 && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <ul style={{ listStyle: "none", paddingLeft: "20px" }}>
                        {menu.submenus.map((submenu) => (
                          <li key={submenu.id}>
                            <div
                              onClick={() => handleSubmenuClick(submenu.routes)}
                              style={{
                                cursor: "pointer",
                                padding: "8px",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px", // Add spacing for submenu items
                              }}
                            >
                              <NavToolTip text={submenu.name}>
                                {getIcon(submenu.icon)}
                              </NavToolTip>
                              {open && submenu.name}{" "}
                              {/* Only show name if sidebar is open */}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </>
        )}
      </Drawer>
    </Box>
  );
}
